import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { personaApiURL } from './apiRoutes';
import { PersonaSummary } from '../user/person/head-card/models/personaSummary';
import { NewPersona } from '../models/persona/newPersona';
import sortHelper from 'src/app/helpers/sort';


@Injectable({
  providedIn: 'root',
})
export class PersonaService {
  constructor(public http: HttpClient) {}

  createPersona(data: NewPersona){
    return this.http.post(personaApiURL, data).toPromise();
  }

  getPersonaSummary(id: string): Promise<PersonaSummary> {
    return this.http.get<PersonaSummary>(personaApiURL + '/' + id + '/head').toPromise();
  }

  getPersonaPhoto(id: string) {
    return this.http.get(personaApiURL + '/' + id + '/head/photo', { responseType: 'blob' as 'json', observe: 'response' }).toPromise();
  }

  deletePersona(id: string): Promise<any> {
    return this.http.put<any>(personaApiURL + '/' + id + '/status/delete', {}).toPromise();
  }

  archivePersona(id: string): Promise<any> {
    return this.http.put<any>(personaApiURL + '/' + id + '/status/archive', {}).toPromise();
  }

  unarchivePersona(id: string): Promise<any> {
    return this.http.put<any>(personaApiURL + '/' + id + '/status/unarchive', {}).toPromise();
  }

  undeletePersona(id: string): Promise<any> {
    return this.http.put<any>(personaApiURL + '/' + id + '/status/undelete', {}).toPromise();
  }

  getExtrasForSection(personaId: string, sectionName: string): Promise<PersonaSummary> {
    return this.http.get<PersonaSummary>(personaApiURL + '/' + personaId + '/sections/' + sectionName + '/extras/count').toPromise();
  }

  checkIfPersonaExists(fullName: string) {
    const sort = sortHelper.constructSort([{prop: 'createdAt', dir: 'desc'}]);
    return this.http.get(personaApiURL + '/existing/' + fullName + sort);
  }

  getPersonasForImport(query: string) {
    return this.http.get(personaApiURL + '/import?query=' + query).toPromise();
  }

  importPersona(uid: string) {
    return this.http.post(personaApiURL + '/import?uid=' + uid, {}).toPromise();
  }


 
}
